<div class="grid animate-pulse gap-3 md:grid-cols-[18rem,auto] max-w-[63.75rem] grid-cols-1 rounded-3xl mx-auto shadow-2xl w-full">
    <div class="rounded-t-lg justify-self-start">
      <div
        class="rounded-3xl w-[280px] h-[280px] bg-pm-black"
      />
    </div>
    <div class="rounded-3xl">
      <div class="flex m-auto w-full p-5 flex-col">
        <p
          class="px-1 py-[.125rem] bg-pm-yellow/80 self-start w-[100px] h-4 rounded-full"
        >
        </p>
          <h3 class="text-4xl font-semibold my-4 bg-pm-black/30 w-1/2 h-7 rounded-full"></h3>
          <div class="text-2xl text-pm-black mb-5  bg-pm-black/70  h-7 rounded-full"></div>
          <div class="text-2xl text-pm-black mb-5 bg-pm-black/30 w-10/12 h-8 rounded-full">&emsp13;
          </div>
          <div class="text-2xl text-pm-black mb-5 bg-pm-pink h-7 w-1/3 rounded-full">
          </div>
      </div>
    </div>
  </div>